// components/common/SearchBox.jsx
import React from "react";

export default function SearchBox({ keyword, onChange, onSearch, onReset }) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  return (
    <div className="search_box">
      <input type="text" placeholder="이름을 입력해주세요." value={keyword} onChange={onChange} onKeyDown={handleKeyDown}/>
      <button className="search" onClick={onSearch}>검색</button>
      <button className="reset" onClick={onReset}>초기화</button>
    </div>
  );
}
